import { MdOutlineKeyboardBackspace } from "react-icons/md";
import { useNavigate } from "react-router-dom";

export default function SectionOne()
{
    const navigate=useNavigate();
    return(
        <section className="mb-3 md:mb-4">
            <div className="text-base md:text-lg xl:text:xl font-medium flex items-center flex-row space-x-1"
            onClick={()=>navigate(-1)}>
                <MdOutlineKeyboardBackspace />
               <p>Invoice Preview</p>
           </div>
        </section>
    );
}